import {getYearOfDisplayByUserRepository,} from "../Infrastructure/YearsUser.repository";

export async function getYearOfDisplayUserByUserLogic(id) {
  return getYearOfDisplayByUserRepository(id);
}